import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
export * from './bootstrap';
export function mockVertical() {
  return _mockVertical.apply(this, arguments);
}

function _mockVertical() {
  _mockVertical = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
    var _yield$import, doMock;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import('./mockVertical');

          case 2:
            _yield$import = _context.sent;
            doMock = _yield$import.doMock;
            return _context.abrupt("return", doMock());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _mockVertical.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6WyJtb2NrVmVydGljYWwiLCJkb01vY2siXSwibWFwcGluZ3MiOiI7O0FBQUEsY0FBYyxhQUFkO0FBRUEsZ0JBQXNCQSxZQUF0QjtBQUFBO0FBQUE7Ozs2REFBTztBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxtQkFDb0IsT0FBK0MsZ0JBQS9DLENBRHBCOztBQUFBO0FBQUE7QUFDR0MsWUFBQUEsTUFESCxpQkFDR0EsTUFESDtBQUFBLDZDQUVFQSxNQUFNLEVBRlI7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsRyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vYm9vdHN0cmFwJztcblxuZXhwb3J0IGFzeW5jIGZ1bmN0aW9uIG1vY2tWZXJ0aWNhbCgpIHtcbiAgY29uc3QgeyBkb01vY2sgfSA9IGF3YWl0IGltcG9ydCgvKiB3ZWJwYWNrQ2h1bmtOYW1lOiBcIm1vY2stdmVydGljYWxcIiAqLyAnLi9tb2NrVmVydGljYWwnKTtcbiAgcmV0dXJuIGRvTW9jaygpO1xufVxuIl19